/**
 * Downloads rows as a CSV file. `columns` is an array of { key, label }.
 * Values containing commas, quotes, or newlines are quoted. A UTF-8 BOM is
 * prefixed so Excel renders special characters correctly.
 *
 * @param {Array<Object>} rows
 * @param {Array<{ key: string, label: string }>} columns
 * @param {string} filename
 */
export function exportToCsv(rows, columns, filename) {
    const escapeCsvValue = (value) => {
        let stringValue = value === null || value === undefined ? '' : String(value);
        // Prevent spreadsheet applications from evaluating externally supplied values as formulas.
        if (/^[=+\-@]/.test(stringValue)) stringValue = `'${stringValue}`;
        return /[",\r\n]/.test(stringValue) ? `"${stringValue.replace(/"/g, '""')}"` : stringValue;
    };
    const header = columns.map((column) => escapeCsvValue(column.label)).join(',');
    const body = rows
        .map((row) => columns.map((column) => escapeCsvValue(row[column.key])).join(','))
        .join('\n');
    const csvContent = `${header}\n${body}`;
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
